$(document).ready(function(){
  $(".feature-row--wrapper").slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    draggable: false,
    slidesToScroll: 1,
    asNavFor: '.feature-row__item.image'
  });

  $(".feature-row__item.image").slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    draggable: false,
    swipe: true,
    slidesToScroll: 1,
    asNavFor: '.feature-row--wrapper'
  });

  $('.arrow--wrapper > .arrow.prev').click(function(){
    $('.feature-row__item.image, .feature-row--wrapper').slick('slickPrev');
  })
  
  $('.arrow--wrapper > .arrow.next').click(function(){
    $('.feature-row__item.image, .feature-row--wrapper').slick('slickNext');
  })

  setTimeout(function() {
    $('[aria-controls="Footer-1494301487049"]').click();
  }, 2000);

  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    $('#necklace .grid--wrapper').on('init', function(event, slick){
      $(".grid__item:first-child:last-child").width($(this).first().find('.grid__item').first().width());
    });
  }
  

  $('[data-section-slider="desktop"] .grid').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    infinite: false,
    prevArrow: $('.arrow.prev.col'),
    nextArrow: $('.arrow.next.col'),
    responsive: [
      {
         breakpoint: 768,
         settings: "unslick"
      }
   ]
  });

  $(".collection-block:not([data-items='1']) .grid--wrapper").each(function(){
    if($(this).children().length > 4) {
      $(this).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        infinite: false,
        prevArrow: $(this).siblings('.grid--header').find(".arrow.prev"),
        nextArrow: $(this).siblings('.grid--header').find(".arrow.next"),
        responsive: [
          {
             breakpoint: 768,
             settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          }
       ]
      });
    } else if ($(this).children().length > 1) {
      if ($(window).width() < 767) {
        $(this).slick({
          slidesToShow: 1.5,
          slidesToScroll: 1,
          autoplay: false,
          infinite: false,
          prevArrow: $(this).siblings('.grid--header').find(".arrow.prev"),
          nextArrow: $(this).siblings('.grid--header').find(".arrow.next")
        });
      }
    }
  });
    


  $(".slider--promo").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    draggable: true,
    slidesToScroll: 1,
    prevArrow: $('.arrow.prev.pro'),
    nextArrow: $('.arrow.next.pro')
  });

  if ($(window).width() < 767) {
    /* the viewport is less than 768 pixels wide */
    $('.logo-grid-mobile').slick({
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: true,
      swipeToSlide: false,
      slidesToShow: 3,
      slidesToScroll: 1,
    });
  }

  $('.drawer__slider-grid').slick({
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    swipeToSlide: false,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    prevArrow: $('.arrow.prev.dr'),
    nextArrow: $('.arrow.next.dr')
  });

  $(".cart-link").click(function(){
    setTimeout(function(){
    $('.drawer__slider-grid').css("opacity", 1);
    $('.drawer__slider-grid').slick('setPosition');
    }, 500);  
  });


  $('.color-swatch').click(function(){
    var varid = $(this).data('variant-id');
    var material = $(this).data('material');
    var prodid = $(this).parent().data('prod-id');
    var handle = $(this).parent().data('prod-handle');
    $(this).parent().siblings('.variant--description').find('span').text(material);
    $('[data-product-id="' + prodid + '"] .grid-product__color-image').removeClass('is-active');
    $('.grid-product__color-image--' + varid).addClass('is-active');
    $('[data-product-id="' + prodid + '"] .grid-product__link, [data-product-id="' + prodid + '"] .grid-product__button').attr('href', "/products/" + handle + "?variant=" + varid);
  });
  
});